import { render, staticRenderFns } from "./companyCard.vue?vue&type=template&id=73574e4f&scoped=true"
import script from "./companyCard.vue?vue&type=script&lang=js"
export * from "./companyCard.vue?vue&type=script&lang=js"
import style0 from "./companyCard.vue?vue&type=style&index=0&id=73574e4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73574e4f",
  null
  
)

export default component.exports